module.exports = __webpack_public_path__ + "img/center.b1ac4f9f.png";